import React from "react";
import LoginStepComponent from "./components/login.component";
import { useCreateMiCeluContext } from "./provider/createMiCelu.provider";
import Code2FAStepComponent from "./components/code.component";
import CreateNewsMiCeluComponent from "./news/create.news.component";
import CreateUserMiCeluComponent from "./used/create.used.component";
import { useCreateNewsMiCeluContext } from "./news/provider/createNewsMiCelu.provider";
import { useCreateUsedMiCeluContext } from "./used/provider/createUsedMiCelu.provider";
import SelectFlowComponent from "./components/select-flow.component";
import RecoverStep from "./components/recover.component";
import CreateSimplyComponent from "./simply/create-simply.component";

const CreateMiCeluComponent = () => {
  const { flow, step } = useCreateMiCeluContext();
  const { step: stepNews } = useCreateNewsMiCeluContext();
  const { step: stepUsed } = useCreateUsedMiCeluContext();

  return (
    <>
      {step < 5 ? (
        <div
          className={`mx-auto w-11/12 md:w-2/3 lg:px-10 ${step !== 3 && "rounded-xl bg-white py-5 shadow-xl"}`}
        >
          <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
            {step === 1 && <LoginStepComponent />}
            {step === 2 && <Code2FAStepComponent />}
            {step === 3 && <SelectFlowComponent />}
            {step === 4 && <RecoverStep />}
          </div>
        </div>
      ) : (
        <>
          <div
            className={`flex w-full md:mt-20 md:flex-col lg:mt-20 xl:mt-20 xl:flex-row 2xl:mt-0 ${stepUsed === 3 && "md:mt-96 lg:mt-96 xl:mt-80"} ${stepNews === 2 && "md:mt-96 lg:mt-96 xl:mt-80"}`}
          >
            <div className="w-full rounded-xl bg-white py-5 shadow-xl md:-mt-1 lg:px-10 xl:mt-10">
              <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
                <CreateSimplyComponent />
                {/*   {flow === "new" && <CreateNewsMiCeluComponent />}
                {flow === "used" && <CreateUserMiCeluComponent />} */}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default CreateMiCeluComponent;
